import * as React from 'react';
import { useState, useEffect } from 'react'
import '@/assets/common.less'
import '../../assets/styles/animate.css'
import {Button, AdvancedLink} from '../../components'
import CyLogo from '../../components/CyLogo'
import { AdvancedLinkProp } from '../../types/components'
import LayoutHeader from '../../components/LayoutHeader'
import OfflineAvatarImage from '../../assets/images/cy/cy-offline-avatar.png'
import OnlineAvatarImage from '../../assets/images/cy/cy-offline-avatar.png'
import { getUserInfo } from '../../request/CyHomepage'
import {
  URL_REGISTER_PC,
  URL_LOGOUT_PC,
  URL_PRACTICE, URL_CY_OVERVIEW, CYAN_NAV_LINKS,
} from '../../constants/CyHomepage'
import { diffEndJump } from '../../utils/tools'
import './index.less'
import Drawer from "../../components/Drawer";
import { LoginModal } from '../../page/cy/components/LoginModal';
import CyanLinksNav from "../../components/LayoutHeader/CyanLinksNav";
import DrawerLinks from "../../components/Drawer/DrawerLinks";


const afterLoginLinks: AdvancedLinkProp[] = [
  {
    title: '进入工作台',
    href: URL_CY_OVERVIEW,
    linkType: 'outer',
    isOpenNewWindow: true
  }
]

const clsPrefix = 'cy-layout'

const commonNode = (props: LayoutProps) => {
  const [ isDrawerVisible, setIsDrawerVisible ] = useState(false)
  const [ isLogin, setIsLogin ] = useState(false)
  const [ account, setAccount ] = useState()
  const [ isModalVisible, setIsModalVisible] = useState(false)


  function useDidShow () {
    console.log('go back')
    fetchUserInfo()
  }

  function pvStat () {
    // 统计官网流量
    if (window) {
      // @ts-ignore
      const { kaq } = window
      // 用 kaq
      kaq('create', `plf-cy-homepage-${window.screen.width < 1024 ? 'wap' : 'pc'}`)
      kaq('set', 'pageType', 0)
      kaq('send', 'pageview')
      // 用 stat-portrait
      // @ts-ignore
      window.xqui.useStat({
        action: 'enter',
        category: '',
        bizType: 5,
        page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
      })
    }
  }

  useEffect(() => {
    
    if (window) {
      // @ts-ignore 注册来源 要在跳转之前种
      if (window.xqui && window.xqui.setPermanentCk) {
        let refer = document.referrer || 'direct'
        // @ts-ignore
        window.xqui.setPermanentCk('cy_mes_info', refer)
      }

      // 防止返回不刷新
      window.addEventListener('pageshow', (e) => {
        if (e.persisted || (window.performance && window.performance.navigation.type === 2)) {
          useDidShow()
        }
      }, false)

      // 统计
      pvStat()
    }

    fetchUserInfo()

  }, [])

  const drawerHeader = (
    <div className={`${clsPrefix}__drawer-header`}>
      <img className='b-user-avatar' src={isLogin ? OnlineAvatarImage : OfflineAvatarImage} alt='avatar' />
    </div>
  )

  function fetchUserInfo () {
    getUserInfo().then((res) => {
      //console.log("用户信息" + res)
      if (res == null || res.code != 200) {
        setIsLogin(false)
      }
      if (res.data) {
        setIsLogin(true)
      } else {
        setIsLogin(false)
      }
      if (res && (res.data.name || res.data.viewName )) {
        setAccount(res.data.name || res.data.viewName || '')
      }
      console.log(res.data,'user',isLogin)
    }).catch((err) => {
      console.log(err, 'err')
      setIsLogin(false)
    })
  }

  function handleLogin () {
    //setIsModalVisible(true)
    //@ts-ignore
    // wap端不支持登录，此地方统计wap端登录点击数
    if (window.screen.width < 1024) {
      // @ts-ignore
      if (window && window.xqui && window.xqui.useStat) {
        // @ts-ignore
        window.xqui.useStat({
          category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_login`,
          page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`,
          action: 'click',
          bizType: 5,
        })
      }
      alert("暂时不支持移动端登录，请去 pc 端进行操作！")
    } else {
      setIsModalVisible(true)
    }

  }

  function handleRegister () {
    // @ts-ignore
    if (window && window.xqui && window.xqui.useStat) {
      // @ts-ignore
      window.xqui.useStat({
        category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_register`,
        page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`,
        action: 'click',
        bizType:5,
      })
    }

    if (window.screen.width < 1024) {
      alert("暂时不支持移动端注册，请去 pc 端进行操作！")
    } else {
      diffEndJump({
        href: URL_REGISTER_PC,
        isOpenNewWindow: false
      })
    }
  }

  function handleLogout () {
    diffEndJump({
      href: URL_LOGOUT_PC,
      wapHref: '',
      isOpenNewWindow: false
    })
  }

  function handleCloseModal () {
    setIsModalVisible(false)
  }

  return (
    props.children
      ? (
        <div className={clsPrefix}>
          <LayoutHeader className={`${clsPrefix}__header`}>
            <div className={`${clsPrefix}__left`}>
              <CyLogo />
              <CyanLinksNav
                navLinks={CYAN_NAV_LINKS}
                className={`${clsPrefix}__nav`}
              />
            </div>
            {
            <div className={`${clsPrefix}__right`}>
              { isLogin ? (
                <div className='user-info'>
                  <span className='info-unit'>你好{`，${account}`}</span>
                  {
                    afterLoginLinks.map((item, index) => (
                      <AdvancedLink key={index} className='info-unit' {...item}>{item.title}</AdvancedLink>
                    ))
                  }
                  <span className='info-unit' onClick={handleLogout}>退出</span>
                </div>
              ) : (
                <div className='login-buttons'>
                  <Button
                    className='login-btn'
                    themeColor='#198ED9'
                    onClick={handleLogin}
                  >
                    登录
                  </Button>
                  <Button
                    className='register-btn'
                    type='primary'
                    themeColor='#198ED9'
                    onClick={handleRegister}
                  >立即注册</Button>
                </div>
              )}
              <div className='wap-menu' onClick={() => setIsDrawerVisible(visible => !visible)}>
                <div className='short-line' />
                <div className='long-line' />
                <div className='short-line' />
              </div>
            </div>}
          </LayoutHeader>

            {props.children}

            <Drawer
              visible={isDrawerVisible}
              title={drawerHeader}
              onClose={() => setIsDrawerVisible(false)}
              style={{ top: '50px' }}
              className={`${clsPrefix}__drawer`}
            >
              <DrawerLinks
                  navLinks={CYAN_NAV_LINKS}
                  className={`drawer-link`}
              />
            </Drawer>

            <AdvancedLink
              href={URL_PRACTICE}
              linkType='outer'
              className={`${clsPrefix}__cy-practice-btn`}
            >
              简单体验
            </AdvancedLink>

            <LoginModal
                visible={isModalVisible}
                onClose={handleCloseModal}
                header='登录畅言'
                headerStyle={{ background: '#FFFFFF', color: '#ffffff' }}
                className='notices-modal'
            >
            </LoginModal>
        </div>
      ) : null
  )
}

interface LayoutProps {
  layoutData?: any,
  children?: any
}

const cyLayout: React.FC<LayoutProps> = (props: LayoutProps) => {
  return commonNode(props)
}

export default cyLayout
